import correct from '@/assets/img/documents/offenders-statement.jpg';
import wrong from '@/assets/img/documents/offenders-statement-wrong.jpg';
import Card from '@/components/Card';
import ChatMessage from '@/components/ChatMessage';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const OFFENDERS_STATEMENT_NAME = 'offenders_statement';

const OffendersStatement = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać oświadczenie sprawcy?'),
    steps: [
      i18n.t('Upewnij się, że widoczna jest data zdarzenia.'),
      i18n.t(
        'Oświadczenie powinno zawierać numer rejestracyjny sprawcy, nazwy towarzystw ubezpieczeniowych pojazdów biorących udział w szkodzie oraz numery polis.'
      ),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <div>
      <Card>
        <Uploader
          title={i18n.t('Oświadczenie sprawcy lub notatka policyjna')}
          instructionProps={instructionProps}
          inputFieldName={OFFENDERS_STATEMENT_NAME}
          attachmentTypeId={ATTACHMENT_TYPES.OSWIADCZENIE_SPRAWCY}
        />
      </Card>
      <ChatMessage
        variant="secondary"
        className="mt-3 lg:mt-5"
        description={
          'Jeśli na miejscu zdarzenia oświadczenie ze sprawcą sporządzono w formie pisemnej, to dodaj zdjęcie lub skan tego oświadczenia. W przypadku, gdy na miejscu była policja, udaj się na najbliższy posterunek i złóż wniosek o wydanie zaświadczenia o zdarzeniu drogowym. Będzie potrzebne w dalszym procesie.'
        }
      />
    </div>
  );
};

export default OffendersStatement;
